import * as React from 'react'

import { GlobalWaitListSignUpWidget } from '@thg-commerce/enterprise-network/src/generated/graphql'
import {
  WaitlistSignup,
  WaitlistSignupProps,
} from '@thg-commerce/enterprise-widget-waitlist-signup'

import { BaseWidgetProps } from '../types'

export enum EnableSignUp {
  OPTIONAL = 'optional',
  AUTO = 'auto',
  NONE = 'none',
}

export type WaitlistSignupWidgetRendererProps = BaseWidgetProps &
  Omit<
    GlobalWaitListSignUpWidget,
    | 'id'
    | 'query'
    | 'errorReturnUrl'
    | 'noAccountReturnUrl'
    | 'registeredReturnUrl'
    | 'enableNameField'
    | 'enableSignUp'
  > & {
    enableSignUp?: EnableSignUp
  }

const getWaitlistSignupWidgetProps = (
  props: WaitlistSignupWidgetRendererProps,
): WaitlistSignupProps => ({
  title: {
    text: props.title || undefined,
  },
  subtitle: {
    text: props.subtitle || undefined,
  },
  buttonText: props.buttonText || undefined,
  campaignCode: props.campaignCode || '',
  gdprDisclaimerText: props.gdprDisclaimerText || undefined,
  emailPlaceholderText: props.placeholderText || undefined,
  fullNamePlaceholderText: props.fullNamePlaceholderText || undefined,
  enableSignUp: props.enableSignUp || undefined,
  signUpCheckboxLabel: props.signUpText || undefined,
  noAccountReturnUrl: props.noAccountReturnUrl,
  registeredReturnUrl: props.registeredReturnUrl,
  errorReturnUrl: props.errorReturnUrl,
})

export const WaitlistSignupWidgetRenderer = (
  props: WaitlistSignupWidgetRendererProps,
) => {
  if (!props || !props.campaignCode) {
    return null
  }

  return <WaitlistSignup {...getWaitlistSignupWidgetProps(props)} />
}
